import React, { useState } from "react";
import { toast } from "sonner";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { useI18n } from "@/context/I18nContext";
import api, { formatApiError } from "@/lib/api";

export default function Reclami() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  usePageMeta(L("Reclami", "Complaints", "Beschwerden"), L("Invia un reclamo a Recovers Crypto.", "Submit a complaint to Recovers Crypto.", "Reichen Sie eine Beschwerde bei Recovers Crypto ein."));
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/leads", { ...form, client_type: "other", message: `[RECLAMO] ${form.message}` });
      toast.success(L("Reclamo inviato. Verrà preso in carico.", "Complaint sent. It will be handled.", "Beschwerde gesendet. Sie wird bearbeitet."));
      setForm({ first_name: "", last_name: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <PageHero eyebrow={L("Reclami", "Complaints", "Beschwerden")} title={L("Invia un reclamo", "Submit a complaint", "Beschwerde einreichen")}
        subtitle={L("Prendiamo sul serio ogni segnalazione. Compila il modulo per inviare un reclamo formale.", "We take every report seriously. Fill out the form to submit a formal complaint.", "Wir nehmen jede Meldung ernst. Füllen Sie das Formular aus, um eine formelle Beschwerde einzureichen.")} />
      <section className="mx-auto max-w-2xl px-4 sm:px-6 lg:px-8 py-20">
        <form onSubmit={submit} className="rounded-xl border border-white/10 bg-navy-paper p-6 space-y-4" data-testid="complaint-form">
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-slate-300">{L("Nome", "First name", "Vorname")}</Label><Input required value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} className="mt-1.5 bg-navy border-white/10" /></div>
            <div><Label className="text-slate-300">{L("Cognome", "Last name", "Nachname")}</Label><Input required value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })} className="mt-1.5 bg-navy border-white/10" /></div>
          </div>
          <div><Label className="text-slate-300">{L("Email", "Email", "E-Mail")}</Label><Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5 bg-navy border-white/10" /></div>
          <div><Label className="text-slate-300">{L("Descrizione del reclamo", "Complaint description", "Beschreibung der Beschwerde")}</Label><Textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1.5 bg-navy border-white/10" /></div>
          <Button type="submit" disabled={loading} className="w-full bg-gold text-navy hover:bg-gold-hover" data-testid="complaint-submit">{loading ? L("Invio…", "Sending…", "Wird gesendet…") : L("Invia reclamo", "Send complaint", "Beschwerde senden")}</Button>
        </form>
      </section>
    </div>
  );
}
